import React from 'react'
import styled, { css } from 'styled-components'

import ColumnGridPanel from 'components/ColumnGridPanel'

import { degrees, capitalize } from 'helpers/formatters'

import { color } from 'styles/colors'

type Props = {
  mode: string
  name: string
  coolSetpoint: string
  heatSetpoint: string
  indoorTemperature: string
  hasAwairDevice: boolean
}

const ZoneBox = ({ mode, name, coolSetpoint, heatSetpoint, indoorTemperature, hasAwairDevice }: Props) => {
  return (
    <>
      <S.ZoneName>{name}</S.ZoneName>
      <ColumnGridPanel.Column>
        <S.ZoneBox aria-label="zone box">
          <S.Row>
            <S.TemperatureAndModeContainer>
              <S.IndoorTemperatureContainer>
                <S.IndoorTemperature>
                  {degrees(indoorTemperature, 1) || '--'}
                </S.IndoorTemperature>

                <S.Mode>{capitalize(mode)}</S.Mode>
              </S.IndoorTemperatureContainer>
            </S.TemperatureAndModeContainer>
            <S.Setpoints>
              {mode && (mode.match(/COOL/gi) || mode.match(/AUTO/gi)) && <S.CoolSetpoint >{degrees(coolSetpoint) || '--'}</S.CoolSetpoint>}
              {mode && (mode.match(/HEAT/gi) || mode.match(/AUTO/gi)) && <S.HeatSetpoint>{degrees(heatSetpoint) || '--'}</S.HeatSetpoint>}
            </S.Setpoints>
          </S.Row>
        </S.ZoneBox>

        <S.SystemBadges>
          { hasAwairDevice && <S.AwairIcon src="/img/awair_badge.svg" alt="awair-icon" aria-label="awair icon" /> }
        </S.SystemBadges>
      </ColumnGridPanel.Column>
    </>
  )
}

export default ZoneBox

const setpointStyle = () => {
  return css`
    font-size: 2rem;
    font-weight: bold;
    padding: 2px 15px;
    border-radius: 10px;
  `
}

const S = {
  ZoneBox: styled.div`
    display: inline-block;
    width: 307px;
    border-radius: 10px;
    background: ${color('DashboardThermostatBackground')};
    text-align: center;
    color: ${color('DashboardThermostatText')};
    margin: 5px auto 5px 5px;
    border: 1px solid ${color('DashboardThermostatBorder')};
  `,
  Row: styled.div`
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 10px 15px;
  `,
  IndoorTemperatureContainer: styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    align-items: flex-start;
  `,
  IndoorTemperature: styled.div`
    font-size:  48px;
    font-weight: bold;
    color: ${color('DashboardThermostatText')};
  `,
  Mode: styled.span`
    align-self: center;
  `,
  Setpoints: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
    color: ${color('DashboardThermostatSetpont')};
  `,
  CoolSetpoint: styled.div`
    ${setpointStyle}
    background: ${color('thermostatBoxCoolSetpoint')};
  `,
  HeatSetpoint: styled.div`
    ${setpointStyle}
    background: ${color('thermostatBoxHeatSetpoint')};
  `,
  SystemBadges: styled.div`
    display: flex;
  `,
  AwairIcon: styled.img`
    width: 100%;
    max-width: 138px;
    margin: 0px auto;
  `,
  TemperatureAndModeContainer: styled.div`
    width: 121px;
    justify-items: center;
  `,
  ZoneName: styled.span`
    font-weight: 600;
    margin-left: 5px;
  `
}
